import Authenticated from '@/Layouts/Authenticated'
import { Link } from '@inertiajs/inertia-react'
import React from 'react'

const Selector = ({ auth, errors, store, branchOffices }) => {
    return (
        <Authenticated
            store={store}
            auth={auth}
            errors={errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight text-center">Selecciona una sucursal para continuar</h2>}
        >
            <div className="max-w-7xl flex flex-col sm:flex-row py-12 px-3 sm:px-6 lg:px-8 gap-8 mx-auto justify-center">
                <div className="sm:w-4/5 flex-col flex gap-3 mx-auto">
                    {
                        branchOffices && branchOffices.map((office, key) => (
                            <Link href={`/${office.slug}/schedule`} key={key} className="block bg-white p-3 rounded mb-3 text-center cursor-pointer hover:bg-gray-200">
                                <h3 className="font-bold text-xl">{office.name}</h3>
                            </Link>
                        ))
                    }
                </div>
            </div>
        </Authenticated>
    )
}

export default Selector
